import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R, { clone } from 'ramda'
import moment from 'moment'

const d = { deep: true }
const DEEP = { deep: true }

export const ReservationBmxRedux = createActions(
  {
    getReservationBmxRequest: ['centerId','query'],
    getReservationBmxSuccess: ['data'],
    getReservationBmxError: ['err'],
    getReservationB2bRequest: ['centerId','query'],
    getReservationB2bSuccess: ['data'],
    getReservationB2bError: ['err'],
    postReservationB2bRequest: ['centerId','data'],
    postReservationB2bSuccess: ['reservations'],
    postReservationB2bError: ['err'],
    authorizeReservationBmxRequest: ['reservationId'],
    authorizeReservationBmxSuccess: ['reservations'],
    authorizeReservationBmxError: ['err'],
    cancelReservationBmxRequest: ['reservationId'],
    cancelReservationBmxSuccess: ['reservations'],
    cancelReservationBmxError: ['err'],
    // updateReservationRequest: ['id','data'],
    // updateReservationSuccess: ['data','id'],
    // updateReservationError: ['err'],
    pendingReservationBmxRequest: ['reservationId'],
    pendingReservationBmxSuccess:['reservations'],
    pendingReservationBmxError:['err'],
    paiedReservationBmxRequest: ['reservationId','paymentId'],
    paiedReservationBmxSuccess:['reservations'],
    paiedReservationBmxError:['err'],
    getStudentPaymentsRequest: ['studentId'],
     getStudentPaymentsSuccess:['data'],
     getStudentPaymentsError:['err'],
  },
  {
    prefix: 'RESERVATIONBMX',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ReservationBmxRedux
export const ReservationBmxTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  postReservation: {
    fetching: false,
    error: null,
  },
  studentPayments:{
    fetching: false,
    error: null,
    results:[],
  },
  deleting: {
    fetching: false,
    error: null,
  },
  getb2b:{
    fetching: false,
    error: null,
    results:[],
  }
}, {
  get: true,
})

const getStudentPaymentsRequest = state => state.merge({
  studentPayments: {
    fetching: true,
    error: null,
  },
}, d)
const getStudentPaymentsSuccess = (state, { data }) => state.merge({
  studentPayments: {
    fetching: false,
    error: null,
    results:data
  },
}, d)

const getStudentPaymentsError = (state, { err }) => state.merge({
  studentPayments: {
    fetching: false,
    error: err,
    results:[]
  },
}, d)
const getReservationBmxRequest = state => state.merge({
  get: {
    fetching: true,
    error: null,
  },
}, d)
const getReservationBmxSuccess = (state, { data }) => state.merge({
  get: {
    fetching: false,
    error: null,
    results:data
  },
}, d)

const getReservationBmxError = (state, { err }) => state.merge({
  get: {
    fetching: false,
    error: err,
    results:[]
  },
}, d)
const getReservationB2bRequest = state => state.merge({
  getb2b: {
    fetching: true,
    error: null,
  },
}, d)
const getReservationB2bSuccess = (state, { data }) => state.merge({
  getb2b: {
    fetching: false,
    error: null,
    results:data
  },
}, d)

const getReservationB2bError = (state, { err }) => state.merge({
  getb2b: {
    fetching: false,
    error: err,
    results:[]
  },
}, d)
const postReservationB2bRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const postReservationB2bSuccess = (state, { reservations }) => {

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    getb2b: {
      results:{
        data:reservations
      }
    }
  }, d)
}
const postReservationB2bError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
const authorizeReservationBmxRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const authorizeReservationBmxSuccess = (state, { reservations }) => {

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:{
        data:reservations
      }
    }
  }, d)
}
const authorizeReservationBmxError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
const cancelReservationBmxRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const cancelReservationBmxSuccess = (state, { reservations }) => {

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:{
        data:reservations
      }
    }
  }, d)
}
const cancelReservationBmxError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)

const pendingReservationBmxRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const pendingReservationBmxSuccess = (state, { reservations }) => {

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:{
        data:reservations
      }
    }
  }, d)
}
const pendingReservationBmxError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
const paiedReservationBmxRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const paiedReservationBmxSuccess = (state, { reservations }) => {

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:{
        data:reservations
      }
    }
  }, d)
}
const paiedReservationBmxError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
// const updateReservationRequest = state => state.merge({
//   postReservation: {
//     fetching: true,
//     error: null,
//   },
// }, d)
// const updateReservationSuccess = (state, { data, id }) => {
//   let reservations = R.clone(state.get.results)
//   const index =  R.findIndex(R.propEq('id', id))(reservations)

//   if (index > -1){
//     reservations.splice(index,1)
//   }

//   if(Array.isArray(data)){
//     data.map(r =>{
//       reservations.push(r)
//     })
//   }
//   else{
//     reservations.push(data)
//   }

//   return state.merge({
//     postReservation: {
//       fetching: false,
//       error: null,
//     },
//     get: {
//       results:reservations
//     }
//   }, d)
// }
// const updateReservationError = (state, { err }) => state.merge({
//   postReservation: {
//     fetching: false,
//     error: err,
//   },
// }, d)
// const  deleteReservationRequest = state => state.merge({
//   deleting: {
//     fetching: true,
//     error: null,
//   },
// }, DEEP)
// const  deleteReservationSuccess = (state,{ id }) => {
//   let reservations = R.clone(state.get.results)
//   const index =  R.findIndex(R.propEq('id', id))(reservations)
//   if (index > -1){
//     reservations.splice(index,1)
//   }

//   return state.merge({
//     deleting: {
//       fetching: false,
//       error: null,
//     },
//     get: {
//       results:reservations
//     }
//   }, DEEP)
// }
// const  deleteReservationFaile = (state,{ error }) => ( state.merge({ deleting: { fetching: false, error }}, DEEP))

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.getReservationBmxRequest]: getReservationBmxRequest,
    [Types.getReservationBmxSuccess]: getReservationBmxSuccess,
    [Types.getReservationBmxError]: getReservationBmxError,
    [Types.authorizeReservationBmxRequest]: authorizeReservationBmxRequest,
    [Types.authorizeReservationBmxSuccess]: authorizeReservationBmxSuccess,
    [Types.authorizeReservationBmxError]: authorizeReservationBmxError,
    [Types.getReservationBmxRequest]: getReservationBmxRequest,
    [Types.getReservationBmxSuccess]: getReservationBmxSuccess,
    [Types.getReservationBmxError]: getReservationBmxError,
    [Types.getReservationB2bRequest]: getReservationB2bRequest,
    [Types.getReservationB2bSuccess]: getReservationB2bSuccess,
    [Types.getReservationB2bError]: getReservationB2bError,
    [Types.postReservationB2bRequest]: postReservationB2bRequest,
    [Types.postReservationB2bSuccess]: postReservationB2bSuccess,
    [Types.postReservationB2bError]: postReservationB2bError,
    [Types.pendingReservationBmxRequest]: pendingReservationBmxRequest,
    [Types.pendingReservationBmxSuccess]: pendingReservationBmxSuccess,
    [Types.pendingReservationBmxError]: pendingReservationBmxError,
    // [Types.updateReservationRequest]: updateReservationRequest,
    // [Types.updateReservationSuccess]: updateReservationSuccess,
    // [Types.updateReservationError]: updateReservationError,
    [Types.cancelReservationBmxRequest]: cancelReservationBmxRequest,
    [Types.cancelReservationBmxSuccess]: cancelReservationBmxSuccess,
    [Types.cancelReservationBmxError]: cancelReservationBmxError,
    [Types.paiedReservationBmxRequest]: paiedReservationBmxRequest,
    [Types.paiedReservationBmxSuccess]: paiedReservationBmxSuccess,
    [Types.paiedReservationBmxError]: paiedReservationBmxError,
    [Types.getStudentPaymentsRequest]: getStudentPaymentsRequest,
    [Types.getStudentPaymentsSuccess]: getStudentPaymentsSuccess,
    [Types.getStudentPaymentsError]: getStudentPaymentsError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  }
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReservationBmxRedux.js